import { Text, Timeline as TimelineUI } from '@mantine/core';
import { IconCalendarEvent } from '@sloyd/icons';
import { Wrapper } from './Timeline.style';

export type TimelineProps = {
  items: Json[];
};

export function Timeline(props: TimelineProps) {
  const { items } = props;

  return (
    <Wrapper className='Timeline-wrapper' data-testid='Timeline-wrapper'>
      <TimelineUI color='grape' active={1} bulletSize={25} lineWidth={2}>
        {items.map((item, index) => (
          <TimelineUI.Item
            key={index}
            bullet={<IconCalendarEvent size={12} />}
            title={item.dateText}
          >
            <Text c='dimmed' size='sm'>
              <Text variant='link' inherit component='h3' fw={500}>
                {item.title}
              </Text>
              <Text variant='link' component='span' inherit>
                {item.description}
              </Text>
            </Text>
            <Text size='xs' mt={4}>
              {item.dateText} ({item.timeToGo})
            </Text>
          </TimelineUI.Item>
        ))}
      </TimelineUI>
    </Wrapper>
  );
}

export default TimelineUI;
